import { DestroyRef, inject, Injectable, Type } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { type ComponentType } from '@angular/cdk/portal';
import { IAbstractModal, IAbstractModalConfig, IModalOptions } from '@dss-libs/shared/type/common-types';

@Injectable({
  providedIn: 'root',
})
export class ModalUiService {
  readonly dialog = inject(MatDialog);
  readonly #destroyRef$ = inject(DestroyRef);

  openGenericModal<C extends ComponentType<unknown>, D, R = unknown>(options: IModalOptions<C, D, R>) {
    const dialogRef = this.dialog.open(options.component, {
      data: options.dialogData,
      panelClass: options.modalDimensionsConfig?.panelClass ?? 'dss-dialog-panel',
      width: options.modalDimensionsConfig?.width,
      minWidth: options.modalDimensionsConfig?.minWidth,
      maxWidth: options.modalDimensionsConfig?.maxWidth,
      minHeight: options.modalDimensionsConfig?.minHeight,
      disableClose: options.modalDimensionsConfig?.disableClose,
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.#destroyRef$))
      .subscribe((result) => {
        if (result) {
          options.onSubmit?.(result);
        } else {
          options.onCancel?.();
        }
      });
  }

  openAbstractModal<C extends IAbstractModal<unknown>, R = unknown>(config: IAbstractModalConfig<Type<C>, R>): void {
    this.openGenericModal(config);
  }
}
